import { Controller } from 'stimulus'
import { useDebounce } from 'stimulus-use'

export default class extends Controller {
  static targets = ['textToCopy', 'successMessage']
  static debounces = ['hideSuccessMessage']
  connect() {
    console.log('connected')
    this.hideClass = 'opacity-0'
    useDebounce(this)
  }

  copyToClipboard(event) {
    const lastIndexToSelectOfText = this.textToCopyTarget.value.length + 1

    this.textToCopyTarget.select()
    this.textToCopyTarget.setSelectionRange(0, lastIndexToSelectOfText) // For mobile devices
    document.execCommand('copy')

    this.showSuccessMessage()
    this.hideSuccessMessage()
  }

  showSuccessMessage() {
    if (this.successMessageTarget.classList.contains(this.hideClass)) {
      this.successMessageTarget.classList.remove(this.hideClass)
    }
  }

  hideSuccessMessage() {
    setTimeout((e) => {
      this.successMessageTarget.classList.add(this.hideClass)
    }, 3000)
  }
}
